import React, { useState } from 'react';
import Fan from "../Animation/fan.json";
import Lottie from 'lottie-react';
import { FaArrowRightLong } from 'react-icons/fa6';
import GetInTouch from './GetInTouch';
import { HiX } from 'react-icons/hi';

const About = () => {
   const [showModal, setShowModal] = useState(false); 
    const openModal = () => {
      setShowModal(true);
    };
  
    const closeModal = () => {
      setShowModal(false);
    };
  return (
    <div className='w-[90%] mx-auto mt-16 flex flex-col lg:flex-row gap-10'>
      {/* Left side */}
      <div className='w-full lg:w-1/2 flex justify-center items-center'>
        <img src="/about_img_2.webp" alt="About" className='w-full h-auto object-contain' />
      </div>

      {/* Right side */}
      <div className='w-full lg:w-1/2'>
        {/* Section Header */}
        <div className='flex items-center gap-2'>
          <Lottie className='w-6' animationData={Fan} />
          <h1 className='text-xl sm:text-2xl text-orange-500 font-bold'>ABOUT US</h1>
        </div>

        <p className='text-2xl sm:text-3xl lg:text-4xl mt-6 font-bold'>
          Turning up the chill factor in your home or office
        </p>

        <p className='mt-6 text-sm sm:text-base text-gray-700'>
          This involves setting up a new air conditioning system in your home or office. It's crucial to ensure that the unit is properly sized for the space and installed correctly for optimal efficiency.
        </p>

        {/* Feature List and Experience */}
        <div className='mt-10 flex flex-col md:flex-row gap-8'>
          <ul className='list-disc list-inside font-semibold text-lg sm:text-xl text-gray-700 marker:text-orange-500'>
            <li>AC Maintenance Service</li>
            <li>Ac Repair</li>
            <li>AC Installation / Uninstallation</li>
          </ul>

          <div className='md:-rotate-90 flex flex-col justify-center items-center'>
            <p className='text-5xl lg:text-6xl stroke-text-about font-bold'>25+</p>
            <p className='text-gray-700 text-xl font-bold'>Experience</p>
          </div>
        </div>

        {/* Read more & Profile */}
        <div className='flex flex-col sm:flex-row gap-4 items-start sm:items-center mt-10'>
          <button onClick={openModal} className='flex gap-2 rounded-md font-semibold items-center uppercase px-4 py-2 bg-orange-500 text-white'>
            Book Now <FaArrowRightLong />
          </button>

          {/* <div className='flex items-center gap-4'>
            <img
              src="https://tse2.mm.bing.net/th?id=OIP.kf9TvsuxepBOhAV4cTHEoAHaHa&pid=Api&P=0&h=180"
              className='w-12 h-12 rounded-full ring-1 ring-orange-600'
              alt="Profile"
            />
            <div>
              <p className='font-semibold'>John Doe</p>
              <p className='text-sm text-gray-600'>Call any time for services</p>
            </div>
          </div> */}
        </div>
      </div>
      {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
                <div className="bg-white w-full max-w-3xl  rounded-lg relative overflow-y-auto max-h-[90vh]">
                  <button
                    onClick={closeModal}
                    className="absolute top-2 right-2 text-2xl text-orange-500 hover:text-red-500"
                  >
                    <HiX />
                  </button>
                  <GetInTouch showModal={showModal} />
                </div>
              </div>
            )}
    </div>
  );
};

export default About;
